var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6965 6.59714L14.3364 1.10778C13.6826 0.454291 12.7675 0.0621902 11.7217 0.0621902H4.00825C2.04721 -0.0685144 0.347656 1.63058 0.347656 3.59106V21.8889C0.347656 23.8494 1.91648 25.5485 4.00825 25.5485H17.0818C19.0429 25.5485 20.7424 23.9802 20.7424 21.8889V9.08043C20.7424 8.16553 20.3502 7.25064 19.6965 6.59714ZM6.62296 10.3875H10.545C11.068 10.3875 11.5909 10.7795 11.5909 11.4331C11.5909 12.0865 11.1987 12.4786 10.545 12.4786H6.62296C6.10001 12.4786 5.57706 12.0865 5.57706 11.4331C5.57706 10.7795 6.10001 10.3875 6.62296 10.3875ZM14.467 17.7066H6.62296C6.10001 17.7066 5.57706 17.3145 5.57706 16.661C5.57706 16.0075 5.96928 15.6154 6.62296 15.6154H14.467C14.99 15.6154 15.5129 16.0075 15.5129 16.661C15.5129 17.3145 14.99 17.7066 14.467 17.7066Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/documentIcon.631dd9ec027a72d3cb975cec34bbc404.svg";
export { ForwardRef as ReactComponent };